import {Async, Loaded} from 'Core/models/Async';
import {createValidatableEmptyEmail} from 'Core/models/Email';
import {createValidatableEmptyString} from 'Core/models/ValidatableNonEmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {BOSAndBeneficiariesUser} from 'Users/models/BOSAndBeneficiariesUser';

export enum BOSAndBeneficiariesUserCreationActionTypes {
  UPDATE_FIELD = 'bosAndBeneficiariesUserCreation/UPDATE_FIELD',
  CHANGE_USER = 'bosAndBeneficiariesUserCreation/CHANGE_USER',
  VALIDATE_USERNAME = 'bosAndBeneficiariesUserCreation/VALIDATE_USERNAME',
  VALIDATE_EMAIL = 'bosAndBeneficiariesUserCreation/VALIDATE_EMAIL',
  ADD_BOSTOOLS_USER = 'bosAndBeneficiariesUserCreation/ADD_BOSTOOLS_USER',
  ADD_BENEFICIARIES_USER = 'bosAndBeneficiariesUserCreation/ADD_BENEFICIARIES_USER',
}

export const updateField = (field: {[key in keyof BOSAndBeneficiariesUser]: BOSAndBeneficiariesUser[key]}) =>
  createAction(BOSAndBeneficiariesUserCreationActionTypes.UPDATE_FIELD, {field});
export const changeUser = (user: Async<BOSAndBeneficiariesUser>) =>
  createAction(BOSAndBeneficiariesUserCreationActionTypes.CHANGE_USER, {user});
export const validateUsername = (username: string) =>
  createAction(BOSAndBeneficiariesUserCreationActionTypes.VALIDATE_USERNAME, username);
export const validateEmail = (email: string) =>
  createAction(BOSAndBeneficiariesUserCreationActionTypes.VALIDATE_EMAIL, email);
export const addBOSToolsUser = (user: BOSAndBeneficiariesUser) =>
  createAction(BOSAndBeneficiariesUserCreationActionTypes.ADD_BOSTOOLS_USER, {user});
export const addBeneficiariesUser = (user: BOSAndBeneficiariesUser) =>
  createAction(BOSAndBeneficiariesUserCreationActionTypes.ADD_BENEFICIARIES_USER, {user});

type BOSAndBeneficiariesUserCreationActions = ReturnType<typeof updateField> | ReturnType<typeof changeUser>;

type BOSAndBeneficiariesUserCreationState = {
  bosAndBeneficiariesUser: Async<BOSAndBeneficiariesUser>;
};

export const DEFAULT_STATE: BOSAndBeneficiariesUserCreationState = {
  bosAndBeneficiariesUser: new Loaded({
    username: createValidatableEmptyString(),
    email: createValidatableEmptyEmail(),
  }),
};

export default (
  state: BOSAndBeneficiariesUserCreationState = DEFAULT_STATE,
  action: BOSAndBeneficiariesUserCreationActions
): BOSAndBeneficiariesUserCreationState => {
  switch (action.type) {
    case BOSAndBeneficiariesUserCreationActionTypes.UPDATE_FIELD:
      return {
        ...state,
        bosAndBeneficiariesUser: new Loaded({
          ...(state.bosAndBeneficiariesUser as Loaded<BOSAndBeneficiariesUser>).Data,
          ...action.payload.field,
        }),
      };
    case BOSAndBeneficiariesUserCreationActionTypes.CHANGE_USER:
      return {
        ...state,
        bosAndBeneficiariesUser: action.payload.user,
      };
    default:
      return state;
  }
};
